import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalComponents from './global-components'
import utils from './utils'
import './libs'
import VueClipboard from 'vue3-clipboard'
import VueApexCharts from 'vue3-apexcharts'
import globalFilter from './libs/filter-helpers'
import envWrapper from './utils/envWrapper'

// SASS Theme
import './assets/sass/app.scss'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true
  })

globalComponents(app)
utils(app)
globalFilter(app)
envWrapper(app)

app.mount('#app')
